import { createConfirmation } from "react-confirm";
import MyAlertDialog from "./MyAlertDialog";

export const showMyAlertDialog = createConfirmation(MyAlertDialog);
